/**
 * @file action base class
 */

class Action {
    before() {}
    after() {}
    toPlainObject() {
        return Object.assign({}, this, {
            type: this.constructor
        });
    }
}

/**
 * @see http://redux.js.org/docs/api/applyMiddleware.html
 */
function middleware(store) {
    return (next) => (action) => {
        if (action instanceof Action) {
            return Promise.resolve().then(() => {
                return action.before(store)
            }).then(() => {
                return next(action.toPlainObject());
            }).then(() => {
                action.after();
            });
        } else {
            return next(action);
        }
    }
}
export {middleware};
export default Action;



// WEBPACK FOOTER //
// ./src/lib/Action.js